import React, { useMemo, useState } from "react";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";

import DashboardLayout from "tools/LayoutContainers/DashboardLayout";
import DashboardNavbar from "tools/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const officersRows = [
  {
    name: "Clay Miller",
    company: "Burford Corp.",
    email: "cmiller@burford.com",
    boardMember: "President",
    term: "2025/2026",
    category: "Equipment",
    address: "11284 OK-74, Maysville, OK 73057",
  },
  {
    name: "Peter Matthaei",
    company: "Dakota MB",
    email: "pmatthaei@dakotablenders.net",
    boardMember: "1st VP",
    term: "2025/2026",
    category: "Milling",
    address: "1430 41st St N, Fargo, ND 58102",
  },
  {
    name: "James Boddicker",
    company: "Sosland Publishing",
    email: "jboddicker@sosland.com",
    boardMember: "2nd VP",
    term: "2025/2026",
    category: "Media",
    address: "2345 Grand Blvd Suite 1950, Kansas City, MO 64108",
  },
  {
    name: "Joe Marx",
    company: "D.Thomas & Associates",
    email: "jpmarx@dthos.com",
    boardMember: "Secretary/Treasurer",
    term: "2025/2026",
    category: "Packaging",
    address: "1717 W 91 Pl, Kansas City, MO 64114",
  },
];

const class2025to2028Rows = [
  {
    name: "Tim Marron",
    company: "BCW Food Products",
    email: "tmarron@bcwilliams.com",
    boardMember: "Corporate Member",
    term: "2025/2028",
    category: "Ingredients",
    address: "6000 Denton Dr, Dallas, TX 75235",
  },
  {
    name: "Jordon Hale",
    company: "SPF Groups",
    email: "jordonhale@spf-mail.com",
    boardMember: "At Large Member",
    term: "2025/2028",
    category: "Equipment",
    address: "114 Pat Joiner Blvd, Byron, GA 31008",
  },
  {
    name: "Sam Scott",
    company: "Corbion",
    email: "sam.scott@corbion.com",
    boardMember: "Corporate Member",
    term: "2025/2028",
    category: "Ingredients",
    address: "8250 Flint Street Lenexa, KS 66214",
  },
  {
    name: "Chris Isom",
    company: "Coperion",
    email: "christopher.isom@coperion.com",
    boardMember: "At Large Member",
    term: "2025/2028",
    category: "Equipment",
    address: "4346 Clary Blvd, Kansas City, MO 64130",
  },
  {
    name: "Jay Hardy",
    company: "J&K Ingredients",
    email: "jhardy@jkingredients.net",
    boardMember: "Corporate Member",
    term: "2025/2028",
    category: "Ingredients",
    address: "160 E 5th St, Paterson, NJ 07524",
  },
  {
    name: "Blair Chastain",
    company: "Kwik Lok",
    email: "blairc@kwiklok.com",
    boardMember: "At Large Member",
    term: "2025/2028",
    category: "Equipment",
    address: "2712 S 16th Ave, Yakima, WA 98903",
  },
  {
    name: "Audrey St. Onge",
    company: "Lallemand",
    email: "astonge@lallemand.com",
    boardMember: "Corporate Member",
    term: "2025/2028",
    category: "Ingredients",
    address: "1620 rue Prefontaine, Montreal, Quebec, Canada H1W 2N8",
  },
  {
    name: "Open Seat",
    company: "BakeMark",
    email: "",
    boardMember: "At Large Member",
    term: "2025/2028",
    category: "Ingredients",
    address: "7351 Crider Ave, Pico Rivera, CA 90660",
  },
  {
    name: "Michelle Pournelle",
    company: "Benchmark Automation",
    email: "michelle.pournelle@promachbuilt.com",
    boardMember: "Corporate Member",
    term: "2025/2028",
    category: "Equipment",
    address: "380 Commerce Blvd, Athens, GA 30606",
  },
  {
    name: "Ron Cardey",
    company: "St. John's Packaging",
    email: "rcardey@sjpack.com",
    boardMember: "At Large Member",
    term: "2025/2028",
    category: "Packaging",
    address: "2619 Phoenix Dr, Greensboro, NC 27406",
  },
];

const class2026Rows = [
  {
    name: "Brandon Brilliant",
    company: "AMF Bakery Systems",
    email: "bbrilliant@amfbakery.com",
    boardMember: "Corporate Member",
    term: "2026",
    category: "Equipment",
    address: "2115 West Laburnum Avenue, Richmond, VA 23227",
  },
  {
    name: "Brian Kaufmann",
    company: "PPC Flexible Packaging",
    email: "brian.kaufmann@ppcflex.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Packaging",
    address: "1111 Busch Pkwy, Buffalo Grove, IL 60089",
  },
  {
    name: "Bradley Pollack",
    company: "Dawn Foods Global",
    email: "Bradley.Pollack@Dawnfoods.com",
    boardMember: "Corporate Member",
    term: "2026",
    category: "Ingredients",
    address: "3333 Sargent Rd, Jackson, MI 49201",
  },
  {
    name: "Charlie Rea",
    company: "IFF",
    email: "charlie.rea@iff.com",
    boardMember: "Corporate Member",
    term: "2026",
    category: "Ingredients",
    address: "4 New Century Pkwy, New Century, KS 66031",
  },
  {
    name: "Crockett Cobble",
    company: "Jennings Cobble",
    email: "cobbleco2@aol.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Packaging",
    address: "1018 Dallas Rd, Chattanooga, TN 37405",
  },
  {
    name: "Paul Lattan",
    company: "Avant Food Media",
    email: "paul@avantfoodmedia.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Media",
    address: "1703 Wyandotte St #300, Kansas City, MO 64108",
  },
  {
    name: "John Johansen",
    company: "Malt Products",
    email: "john@maltproducts.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Ingredients",
    address: "88 Market Street, Saddle Brook, NJ 07663",
  },
  {
    name: "Bradley Cain",
    company: "Cain",
    email: "jb.cain@cainfood.com",
    boardMember: "Corporate Member",
    term: "2026",
    category: "Ingredients",
    address: "8401 Sovereign Row, Dallas, TX 75247",
  },
  {
    name: "Jill Stang",
    company: "LeSaffre",
    email: "j.stang@lesaffre.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Ingredients",
    address: "7475 W Main St, Milwaukee, WI 53214",
  },
  {
    name: "Jeff Eller",
    company: "AB Mauri",
    email: "jeff.eller@abmauri.com",
    boardMember: "At Large Member",
    term: "2026",
    category: "Ingredients",
    address: "4240 Duncan Ave #150, St. Louis, MO 63110",
  },
];

const class2027Rows = [
  {
    name: "Chris Gillmar",
    company: "ADM",
    email: "Chris.Gillmar@adm.com",
    boardMember: "At Large Member",
    term: "2027",
    category: "Milling",
    address: "4666 E Faries Pkwy, Decatur, IL 62526",
  },
  {
    name: "Angie Miller",
    company: "Ardent Mills",
    email: "Angie.Miller@ardentmills.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Milling",
    address: "1875 Lawrence Street, Suite 1200, Denver, CO 80202",
  },
  {
    name: "Daniel Robinson",
    company: "Amcor",
    email: "Daniel.Robinson@amcor.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Packaging",
    address: "3 Parkway N Ste 300, Deerfield, IL 60015",
  },
  {
    name: "Dennis Gunnell",
    company: "Formost Fuji",
    email: "dennisg@formostfuji.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Equipment",
    address: "905 80th St SW, Everett, WA 98203",
  },
  {
    name: "Teresa Ruder",
    company: "LeMatic",
    email: "truder@lematic.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Equipment",
    address: "2410 W Main St, Jackson, MI 49203",
  },
  {
    name: "Bruce King",
    company: "Grain Craft",
    email: "bking@graincraft.com",
    boardMember: "At Large Member",
    term: "2027",
    category: "Milling",
    address: "201 West Main St, Suite 203, Chattanooga, TN 37408",
  },
  {
    name: "Tim Tuzik",
    company: "Manildra Group USA",
    email: "ttuzik@manildrausa.com",
    boardMember: "At Large Member",
    term: "2027",
    category: "Ingredients",
    address: "4501 College Blvd #310, Leawood, KS 66211",
  },
  {
    name: "Ryan Hemingson",
    company: "Amber Wave",
    email: "rhemingson@amberwaveusa.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Ingredients",
    address: "1664 E 100 Rd, Phillipsburg, KS 67661",
  },
  {
    name: "Kevin Sebby",
    company: "Miller Milling",
    email: "ksebby@millermilling.com",
    boardMember: "Corporate Member",
    term: "2027",
    category: "Milling",
    address: "221 Fairmount St, Saginaw, TX 76179",
  },
  {
    name: "Morgan Murphy",
    company: "Mother Murphy's",
    email: "MMURPHY@MotherMurphys.com",
    boardMember: "At Large Member",
    term: "2027",
    category: "Ingredients",
    address: "2826 South Elm-Eugene St, Greensboro, NC 27406",
  },
];

const regionalRows = [
  {
    name: "James Boddicker",
    company: "Sosland Publishing",
    email: "jboddicker@sosland.com",
    boardMember: "MWATBI - President",
    term: "2026",
    category: "Regional",
    address: "",
  },
  {
    name: "Adam Ungashick",
    company: "Lesaffre",
    email: "A.ungashick@lesaffre.com",
    boardMember: "SWAT - President",
    term: "2026",
    category: "Regional",
    address: "",
  },
  {
    name: "John Johansen",
    company: "Malt Products",
    email: "john@maltproducts.com",
    boardMember: "New Jersey #9 - Past President",
    term: "2026",
    category: "Regional",
    address: "",
  },
];

const pastPresidentsRows = [
  {
    name: "Bill Gross (2023/2024)",
    company: "PPC Flexible Packaging",
    email: "Bill.Gross@ppcflex.com",
    boardMember: "Immediate Past President",
    term: "2024/2025",
    category: "Packaging",
    address: "",
  },
  {
    name: "Dean Modglin (2021/2022)",
    company: "Lesaffre",
    email: "d.modglin@lesaffre.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "DJ LeCrone (2019/2020)",
    company: "LeMatic",
    email: "djlecrone@lematic.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Equipment",
    address: "",
  },
  {
    name: "John Hellman (2017/2018) - Retired",
    company: "Retired - McGahee, Lacy & Associates",
    email: "jrhellman57@gmail.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Packaging",
    address: "",
  },
  {
    name: "Thomas McCurry (2015/2016)",
    company: "Cain Food",
    email: "t.mccurry@cainfood.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "Rick McGrath (2013/2014)",
    company: "Lockton Companies",
    email: "rmcgrath@lockton.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Insurance",
    address: "",
  },
  {
    name: "Tim S. Miller (2011/2012) - Retired",
    company: "Retired - Grain Craft",
    email: "tmiller@graincraft.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Milling",
    address: "",
  },
  {
    name: "Gary M. Edwards (2009/2010) - Retired",
    company: "Retired - Lallemand",
    email: "gedwards@lallemand.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "Brad Burris (2007/2008)",
    company: "D.Thomas & Associates",
    email: "jbburris@dthos.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Packaging",
    address: "",
  },
  {
    name: "Mike Gude (2005/2006)",
    company: "Sosland Publishing",
    email: "mgude@sosland.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Publishing",
    address: "",
  },
  {
    name: "Gary Cain (2003/2004) - Retired",
    company: "Retired - Cain Food",
    email: "gcain128@icloud.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "Fred Springer (2001/2002) - Retired",
    company: "Retired - Burford Corp.",
    email: "fspringer@outlook.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Equipment",
    address: "",
  },
  {
    name: "John Riesch - Retired",
    company: "Retired - Lesaffre",
    email: "jnriesch45@gmail.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "William T. McCurry - Retired",
    company: "Retired - Manildra",
    email: "wtmccurry@hotmail.com",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
  {
    name: "James R. Lynch",
    company: "D. Thomas & Associates",
    email: "n/a",
    boardMember: "Past President",
    term: "Past President",
    category: "Packaging",
    address: "",
  },
  {
    name: "David S. Murphy",
    company: "Mother Murphy's Labs",
    email: "n/a",
    boardMember: "Past President",
    term: "Past President",
    category: "Ingredients",
    address: "",
  },
];

function SectionGrid({ title, rows, onSelect }) {
  return (
    <MDBox p={3}>
      <MDBox mb={3} p={2}>
        <MDTypography variant="h5" fontWeight="medium" pb={2}>
          {title}
        </MDTypography>

        <Grid container spacing={2}>
          {rows.map((member) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={`${title}-${member.name}-${member.company}`}>
              <Card
                onClick={() => onSelect({ ...member, section: title })}
                sx={{
                  p: 2,
                  height: "100%",
                  cursor: "pointer",
                  border: "1px solid",
                  borderColor: "grey.300",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                    borderColor: "primary.main",
                  },
                }}
              >
                <MDTypography variant="h6" fontWeight="bold" mb={1}>
                  {member.name}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.boardMember}
                </MDTypography>
                {member.term &&
                  member.term.trim().toLowerCase() !== (member.boardMember || "").trim().toLowerCase() && (
                    <MDTypography variant="button" color="text" display="block">
                      {member.term}
                    </MDTypography>
                  )}
                <MDTypography variant="button" color="text" display="block">
                  {member.company}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.category}
                </MDTypography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default function Directors() {
  const [selectedMember, setSelectedMember] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedSection, setSelectedSection] = useState("All");

  const sections = useMemo(
    () => [
      { title: "Officers - 2025/2026", rows: officersRows },
      { title: "Class of 2026", rows: class2026Rows },
      { title: "Class of 2027", rows: class2027Rows },
      { title: "Class of 2028", rows: class2025to2028Rows },
      { title: "Regional Division Representatives", rows: regionalRows },
      { title: "Past Presidents", rows: pastPresidentsRows },
    ],
    []
  );

  const categoryOptions = useMemo(() => {
    const categories = new Set();
    sections.forEach((section) => {
      section.rows.forEach((member) => {
        if (member.category) categories.add(member.category);
      });
    });
    return ["All", ...Array.from(categories).sort()];
  }, [sections]);

  const sectionOptions = useMemo(() => ["All", ...sections.map((section) => section.title)], [sections]);

  const filteredSections = useMemo(() => {
    const needle = searchTerm.trim().toLowerCase();

    return sections
      .filter((section) => selectedSection === "All" || section.title === selectedSection)
      .map((section) => ({
        ...section,
        rows: section.rows.filter((member) => {
          const matchesCategory = selectedCategory === "All" || member.category === selectedCategory;
          if (!matchesCategory) return false;
          if (!needle) return true;

          return [member.name, member.company, member.boardMember, member.term, member.category]
            .join(" ")
            .toLowerCase()
            .includes(needle);
        }),
      }))
      .filter((section) => section.rows.length > 0);
  }, [sections, searchTerm, selectedCategory, selectedSection]);

  return (
    <DashboardLayout>
      <DashboardNavbar onSsearch={false} />
      <MDTypography variant="h5" fontWeight="medium" pb={3}>
        The Allied Trades of the Baking Industry Board
      </MDTypography>

      <MDBox display="flex" alignItems="center">
        <Card sx={{ overflow: "visible", width: "100%" }}>
          <MDBox p={4} pb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <TextField
                  fullWidth
                  label="Search"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  placeholder="Name, company, role, term..."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 56,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 56,
                    },
                  }}
                >
                  <InputLabel>Category</InputLabel>
                  <Select
                    label="Category"
                    value={selectedCategory}
                    onChange={(event) => setSelectedCategory(event.target.value)}
                  >
                    {categoryOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 56,
                    },
                  }}
                >
                  <InputLabel>Section</InputLabel>
                  <Select
                    label="Section"
                    value={selectedSection}
                    onChange={(event) => setSelectedSection(event.target.value)}
                  >
                    {sectionOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={1}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedCategory("All");
                    setSelectedSection("All");
                  }}
                  sx={{
                    height: 56,
                    width: "100%",
                    fontWeight: 700,
                    letterSpacing: "0.02em",
                    color: "primary.main",
                    borderColor: "primary.main",
                    "&:hover": {
                      borderColor: "primary.dark",
                      backgroundColor: "rgba(25, 118, 210, 0.06)",
                    },
                  }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </MDBox>

          {filteredSections.map((section) => (
            <SectionGrid key={section.title} title={section.title} rows={section.rows} onSelect={setSelectedMember} />
          ))}

          {filteredSections.length === 0 && (
            <MDBox px={5} pb={4}>
              <MDTypography variant="button" color="text">
                No board members match your current filters.
              </MDTypography>
            </MDBox>
          )}

        </Card>
      </MDBox>

      <Dialog open={Boolean(selectedMember)} onClose={() => setSelectedMember(null)} fullWidth maxWidth="sm">
        <DialogTitle>{selectedMember?.name}</DialogTitle>
        <DialogContent>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Section:</strong> {selectedMember?.section || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Board Member:</strong> {selectedMember?.boardMember || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Term:</strong> {selectedMember?.term || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Company:</strong> {selectedMember?.company || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Category:</strong> {selectedMember?.category || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Email:</strong> {selectedMember?.email || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block">
            <strong>Address:</strong> {selectedMember?.address || "N/A"}
          </MDTypography>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}
